//PACKAGES
import axios from "axios";
//CONSTANT
import { STORAGE_KEY } from "../constants";

async function getHeaders() {
  const user = localStorage.getItem(STORAGE_KEY.USER_DETAILS);
  if (user) {
    const userJson = JSON.parse(user);
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + userJson?.token,
    };
  } else {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
  }
}

async function getFormDataHeaders() {
  const user = localStorage.getItem(STORAGE_KEY.USER_DETAILS);
  if (user) {
    const userJson = JSON.parse(user);
    return {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + userJson?.token,
    };
  } else {
    return {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
  }
}

export async function getRequest(url, params) {
  let headers = await getHeaders();

  try {
    let config;

    if (params) {
      config = {
        method: "GET",
        url: url,
        params: params,
        headers: headers,
      };
    } else {
      config = {
        method: "GET",
        url: url,
        headers: headers,
      };
    }

    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    if (err?.response?.data?.message === "Token expire") {
      localStorage.removeItem("user_details_json");
    }
    return getError(err);
  }
}

export async function postRequest(url, params) {
  let headers = await getHeaders();

  try {
    let config;

    if (params) {
      config = {
        method: "POST",
        url: url,
        data: params,
        headers: headers,
      };
    } else {
      config = {
        method: "POST",
        url: url,
        headers: headers,
      };
    }

    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    console.log(err);
    return getError(err);
  }
}

export async function putRequest(url, params, form) {
  let headers = "";
  if (form == "form") {
    headers = await getFormDataHeaders();
  } else {
    headers = await getHeaders();
  }

  try {
    const config = {
      method: "PUT",
      url: url,
      data: params,
      headers: headers,
    };
    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    console.log(err);
    return getError(err);
  }
}

export async function deleteRequest(url, params) {
  let headers = await getHeaders();
  try {
    const config = {
      method: "DELETE",
      url: url,
      data: params,
      headers: headers,
    };
    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    console.log(err);
    return getError(err);
  }
}

export async function postMultipartRequest(url, params) {
  let headers = await getFormDataHeaders();
  try {
    let config;

    if (params) {
      config = {
        method: "post",
        url: url,
        data: params,
        headers: headers,
      };
    } else {
      config = {
        method: "post",
        url: url,
        headers: headers,
      };
    }

    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    console.log(err);
    return getError(err);
  }
}

export async function getMultipartRequest(url, params) {
  let headers = await getFormDataHeaders();
  try {
    let config;

    if (params) {
      config = {
        method: "post",
        url: url,
        data: params,
        headers: headers,
      };
    } else {
      config = {
        method: "post",
        url: url,
        headers: headers,
      };
    }

    const response = await axios(config);
    return getResponse(response);
  } catch (err) {
    console.log(err);
    return getError(err);
  }
}

const getResponse = async (response) => {
  const { status, data } = response;
  const responseStatus = data?.status;
  const message = data?.message ?? "Something went wrong";

  let result = {
    status: status === 200 || status === 201,
    data: data ?? null,
    error: message,
  };

  if (result.status && responseStatus !== undefined) {
    result.status = responseStatus === 200 || responseStatus === 201;
  }

  if (!result.status) {
    result.error = message;
  }

  return result;
};

const getError = (error) => {
  if (error?.response?.data?.status === 404) {
    // localStorage.clear();
  }

  let message = "";
  let obj = null;
  if (error.response) {
    if (error.response.data) {
      obj = error.response.data;
      if (error.response.data.message) {
        if (error.response.data.message === "Token Missing") {
          localStorage.removeItem("user_details_json");
        }
        message = error.response.data.message;
      } else {
        message = JSON.stringify(error.response.data.message);
      }
    } else {
      obj = error.response;
      message = "Something went wrong";
    }
  } else {
    obj = error;
    message = error.message;
  }

  let data = {
    status: false,
    data: obj,
    error: message,
    status_code: error?.response?.status ?? "",
  };
  return data;
};
